import { render, staticRenderFns } from "./CalendarResourceEdit.vue?vue&type=template&id=753b4a37&scoped=true"
import script from "./CalendarResourceEdit.vue?vue&type=script&lang=ts"
export * from "./CalendarResourceEdit.vue?vue&type=script&lang=ts"
import style0 from "./CalendarResourceEdit.vue?vue&type=style&index=0&id=753b4a37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b4a37",
  null
  
)

export default component.exports